<template>
  <div class="container">
    <div class="info">
      <!-- 标题 -->
      <div class="title">{{ $t('common').helpcenter }}</div>
      <!-- 列表 -->
      <div class="listInfo">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`help${dIndex}`"
          @click="$router.push({ name: 'Detail', query: { id: dItem.contentLocalizationId } })">
          <div class="left">
            <div class="ico">
              <img src="@/assets/img/common_help.png" />
            </div>
            <div class="name">{{ dItem.localizationTitle }}</div>
          </div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
        <!-- 分页 -->
        <div class="pagefoot">
          <el-pagination :current-page="parms.pageNum" :page-size="parms.pageSize" layout="prev, pager, next"
            hide-on-single-page :total="total" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import systemApi from '@/api/system'

export default {
  components: {
  },
  data() {
    return {
      parms: {
        pageNum: 1,
        pageSize: 10,
        type: '2'
      },
      oList: [],
      total: 0,
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getContentList()
  },
  methods: {
    // 切换分页
    handleCurrentChange(val) {
      this.parms.pageNum = val
      this.getContentList()
    },
    // 获取内容列表
    async getContentList() {
      const res = await systemApi.getContentList(this.parms)
      this.oList = res.rows
      this.total = res.total
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .title {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .listInfo {
      margin-top: 20px;
      padding-bottom: 80px;

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 25px 15px;
        background: var(--background_color);
        border-bottom: 1px solid var(--info_color);

        .left {
          width: 300px;
          display: flex;
          align-items: center;

          .ico {
            background: #FEB220;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 17px;
              height: 17px;
            }

          }

          .name {
            width: 220px;
            margin-left: 15px;
            font-size: 16px;
            color: var(--text_color);
            line-height: 20px;
          }
        }
      }

      .item:hover {
        background: var(--info_color);
      }

      .pagefoot {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
}

// 分页
::v-deep .el-pagination button {
  color: var(--text_color);
  background-color: var(--background_color);
}

::v-deep .el-pager li {
  background: var(--background_color);
  color: var(--text_color);
}

::v-deep .el-pager li.active {
  color: var(--background_color);
  background: var(--text_color);
  border-radius: 15px;
}
</style>
